import React, { useEffect, useRef } from 'react';

const partners = [
  'https://framerusercontent.com/images/FK2PxMGUliSNEptVBpWhWGjhW4.png',
  'https://framerusercontent.com/images/JN5q8qzSCZ7K4LwF01UYdhkXhmI.png',
  'https://framerusercontent.com/images/rlsK5y9oz2tQ5YKXeUw3yHuCHmQ.png',
  'https://framerusercontent.com/images/4gWMpRVsQK9Ft5gBD0QXiHTlc.png',
  'https://framerusercontent.com/images/29bYpN5ZZIRLBUb7d3V3wqrnO3o.png',
  'https://framerusercontent.com/images/mAqJXI1WqQKj2I8cnIV678ndB0.png',
];

const IntegrationsSection = () => {
  const scrollRef = useRef(null);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;
    let scrollPosition = 0;
    const scroll = () => {
      scrollPosition += 1;
      if (scrollPosition >= scrollContainer.scrollWidth / 4) scrollPosition = 0;
      scrollContainer.scrollLeft = scrollPosition;
    };
    const intervalId = setInterval(scroll, 20);
    return () => clearInterval(intervalId);
  }, []);

  const repeatedPartners = [...partners, ...partners, ...partners, ...partners];

  return (
    <section id="migration" className="py-24 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-5 leading-[1.1] tracking-tight">
            Seamless data migration from your current PMS.
          </h2>
          <p className="text-lg text-gray-400">
            We handle migration, QA the data, and get you live on Asha fast.
          </p>
        </div>

        <div className="relative overflow-hidden">
          <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-gray-50 to-transparent z-10" />
          <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-gray-50 to-transparent z-10" />
          <div ref={scrollRef} className="flex space-x-10 overflow-hidden py-6" style={{ scrollBehavior: 'auto' }}>
            {repeatedPartners.map((partner, index) => (
              <div key={index} className="flex-shrink-0 w-44 h-20 bg-white rounded-2xl flex items-center justify-center p-5 shadow-[0_1px_3px_rgba(0,0,0,0.04)] border border-gray-100 hover:shadow-md hover:border-gray-200 transition-all duration-300">
                <img src={partner} alt={`Partner ${index}`} className="max-w-full max-h-full object-contain" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntegrationsSection;
